import { usePermissions } from 'hooks/usePermissions';
import { useShowController } from 'react-admin';
import { ShowPageTabbed } from 'shared/react-admin/Pages';
import { Tab } from 'shared/react-admin/Tab/Tab';

import { ProvidersShowCommonInfo } from './ProvidersShowCommonInfo';
import { ProvidersShowWhiteIpAddresses } from './ProvidersShowWhiteIpAddresses/ProvidersShowWhiteIpAddresses';

export const ProvidersShow = (): JSX.Element => {
  const { hasResourceAccess } = usePermissions();
  const { record } = useShowController();

  return (
    <ShowPageTabbed
      headerTitle={{ titleText: record?.name }}
      listName="Провайдеры"
      title="Просмотр провайдера"
    >
      <Tab label="Информация">
        <ProvidersShowCommonInfo record={record} />
      </Tab>
      {hasResourceAccess('provider_white_ip_addresses') && (
        <Tab label="Белые IP-адреса">
          <ProvidersShowWhiteIpAddresses providerId={record?.['@id']} />
        </Tab>
      )}
    </ShowPageTabbed>
  );
};
